import { useEffect, useRef } from "react";
import { create } from "canvas-confetti";
import { Colors } from "@zapier/design-system";

import styles from "./Confetti.module.css";

export function Confetti() {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    const setCanvasSize = () => {
      if (canvasRef.current) {
        canvasRef.current.width = window.innerWidth;
        canvasRef.current.height = window.innerHeight;
      }
    };

    // Initial size
    setCanvasSize();

    const fullPageConfetti = create(canvasRef.current, {
      resize: true,
      useWorker: false, // Needs to be false since canvas worker stops the page from rendering behind
      disableForReducedMotion: true, // For accessibility
    });

    // Makes the effect of falling down
    fullPageConfetti({
      particleCount: 500,
      scalar: 1.3, // size of each particle
      angle: 90, // Makes it rain straight down
      spread: 120, // This is the largest angle the particles will be emitted from
      startVelocity: 90,
      gravity: 2.5, // Speed at which the particles fall
      ticks: 1000, // Number of movements per particle
      origin: {
        x: 0.5, // Start from center-X on the screen
        y: 0, // Start from top of the screen to simulate falling down
      },
      colors: [
        Colors.BrandLavender,
        Colors.BrandPeach,
        Colors.BrandOrange,
        Colors.BrandSky,
      ],
    });

    // It's critical to not resize the canvas after this point if using `useWorker: true`
    window.addEventListener("resize", setCanvasSize);

    return () => {
      window.removeEventListener("resize", setCanvasSize);
      fullPageConfetti.reset();
    };
  }, []);

  return (
    <div className={styles.confettiWrapper}>
      <canvas ref={canvasRef} />
    </div>
  );
}
